module.exports = __webpack_public_path__ + "public/img/tiku_cbg3select.2e0cfe65.png";